import { render } from "./Confindustria.vue?vue&type=template&id=ac997188&scoped=true&ts=true"
import script from "./Confindustria.vue?vue&type=script&lang=ts"
export * from "./Confindustria.vue?vue&type=script&lang=ts"

import "./Confindustria.vue?vue&type=style&index=0&id=ac997188&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac997188"]])

export default __exports__